<div class="title-wrapper">
  <h1 class="section-title rp-text-primary-dark" [innerHTML]="'landing.pricing.title' | translate"></h1>
</div>
<app-pricing-grid [princingData]="PRICING_DATA"></app-pricing-grid>
